import React, { useEffect, useState } from "react";
import ResultPopUpSucccess from "./result/ResultPopUpSuccess";
import ResultPopUpWithGifts from "./result/ResultPopUpWithGifts";
import ResultPopUpFail from "./result/ResultPopUpFail";
import { View } from "react-native";
import { DATA_SERVICE } from "../dataSchema/DataService";

const renderResult=(data, requestClose, isZmp)=>{
  if(data && data.status && data.data){
    if(data.status.success){
      if(data.data.receiveGift){
        return <ResultPopUpWithGifts gifts={DATA_SERVICE.data.mobileForm.giftPackages.giftDetails} requestClose={requestClose} isZmp={isZmp}></ResultPopUpWithGifts>;
      }else{
        return <ResultPopUpSucccess requestClose={requestClose} isZmp={isZmp}></ResultPopUpSucccess>;
      }
    }else{
      return <ResultPopUpFail requestClose={requestClose}></ResultPopUpFail>;
    }
  }else{
    return <ResultPopUpFail requestClose={requestClose}></ResultPopUpFail>;
  }
}

const ResultPopUp = ({data, handleClose})=>{
    const [isZmp, setIsZmp] = useState(false)

    useEffect(()=>{
      try{
        // central zmp detection: query param zmp=1
        // @ts-ignore
        const search = (typeof window !== 'undefined' && window.location && window.location.search) ? window.location.search : ''
        const params = new URLSearchParams(search)
        const zmp = params.get('zmp')
        const detected = zmp === '1'
        console.log('[ResultPopUp] zmp param:', zmp, '=> isZmp=', detected)
        setIsZmp(detected)
      }catch(e){
        console.log('[ResultPopUp] detect zmp failed', e)
        setIsZmp(false)
      }
    }, [])

    return(
      <View>
        {
          renderResult(data,handleClose, isZmp)
        }
      </View>
    )
}

export default ResultPopUp